export default {
  'environments.title': 'Gestionar Entornos',
};
